/**
 * (owner, Sep 11: "some of the improvements do not show up on mobile") The phone keeps the page it opened last: the tab lives
 * in the background for days, the installed app resumes it, and a deploy in between never reaches it. So the client
 * asks the server for its build every minute (`/version.json`, written at build time, never cached) and, when the
 * server has moved on, reloads — the moment the tab is hidden (switching apps, locking the phone), so nobody loses a
 * drive to it, and meanwhile a small note offers a tap to reload now. Dev builds ('unknown' or '-dirty') never reload.
 */
/** `hold`: (owner, Sep 25) true while the page is playing in the background (Sound in the background) — a reload there would cut the radio
 *  off, so the note is left for when the player comes back instead */
export function startUpdateCheck(own: string, everyMs = 60000, hold: () => boolean = () => false): void {
  if (!own || own === 'unknown' || own.endsWith('-dirty') || typeof document === 'undefined') return;
  let pending = false, note: HTMLDivElement | undefined;
  const reload = () => { try { location.reload(); } catch { /* ignore */ } };
  const offer = () => {
    if (note) return;
    note = document.createElement('div');
    note.textContent = 'A new version is on the server — tap to reload';
    note.style.cssText = 'position:fixed;left:50%;bottom:14px;transform:translateX(-50%);background:#1b2a3a;color:#fff;padding:8px 14px;border-radius:8px;font:14px system-ui,sans-serif;z-index:1000;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,.4)';
    note.addEventListener('click', reload);
    document.body.appendChild(note);
  };
  const check = async () => {
    if (pending) return;
    try {
      const r = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
      if (!r.ok) return;
      const { version } = (await r.json()) as { version?: string };
      if (!version || version === own) return;
      pending = true;
      if (document.hidden && !hold()) reload(); else offer();
    } catch { /* offline, or a server mid-deploy: try again later */ }
  };
  document.addEventListener('visibilitychange', () => { if (pending && document.hidden && !hold()) reload(); else if (!document.hidden) void check(); });
  setInterval(() => void check(), everyMs);
  setTimeout(() => void check(), 5000);
}
